import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import DropDown      from 'dropdown';
import Utils         from 'utils';

import DraftPreviewModal from './draft-preview-modal';
import PostPreview from '@common/post-preview/_post-preview';
import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';

// -------------------------------------------------------


class DraftContentsHeader extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal: false,
    };
  }
  // -------------------------------------------------------
  
  /*
   * モーダル操作
   */
  toggleModal(flg) {
    this.setState({ modal: flg });
    
    if( flg == true  ) Utils.fixedContents();
    if( flg == false ) Utils.unlockFixedContents();
  }
  // -------------------------------------------------------
  
  /*
   * モーダル操作
   */
  bulkAction() {
    let detail = this.props.detail;
    let edit = Object.assign({}, this.props.edit);
    let contents = this.props.contents;
    
    let chk = confirm('未設定の項目を全て内容OKの状態にしてもよろしいですか？');
    if( chk == false ) return;
    
    // 初期化
    if( edit.draft_caption == undefined ) edit.draft_caption = {};
    if( edit.draft_media   == undefined ) edit.draft_media   = {};
    
    // キャプションを承認状態にする
    for( let i in detail.draft_caption ){
      let d = detail.draft_caption[i];
      if( d.is_approval == null && d.contents_id == contents.id ) edit.draft_caption[i] = { is_approval: 1 };
    }
    detail.post_contents.map((d) => {
      let set_contents_type = {};
      Const.value.contents_type_list.map((c) => { if( c.id == d.media_type ) set_contents_type = c; });
      
      if( (Object.keys(set_contents_type).length > 0 && set_contents_type.caption === true) && detail.draft_caption[d.id] == undefined ){
        if( d.id == contents.id ) edit.draft_caption[d.id] = { is_approval: 1 };
      }
    });
    
    // メディアを承認状態にする
    for( let i in detail.draft_media ){
      detail.draft_media[i].map((d) => { if( d.is_approval == null && d.contents_id == contents.id ) edit.draft_media[d.id] = { is_approval: 1 }; });
    }
    
    this.props.update_ev.bind(this)(edit);
  }
  // -------------------------------------------------------
  
  render() {
    let base = this.props.base;
    let detail = this.props.detail;
    let contents = this.props.contents;
    
    let is_edit_mode = (this.props.edit_mode) ? 'edit_mode' : '';
    
    // 完了済みのゲストは非表示にする
    if( detail.is_guest_complete_mode === true ) return null;
    
    let menu = [<li key="dl" className="border"><a href={detail.excel_download}>エクセルのDL</a></li>];
    if( detail.excel_download_empty != null ) menu.push(<li key="dl_empty" className="border"><a href={detail.excel_download_empty}>修正依頼が未記入のエクセルのDL</a></li>);
    
    return (
      <div className="draft-contents-header">
        
        {( detail.my_authority != null ) &&
          <div className="bulk-done" onClick={this.bulkAction.bind(this)}>
            <i className="material-icons">task_alt</i>一括内容OK
          </div>
        }
        
        <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>プレビュー</Tooltip>}>
          <a className="button-item on" onClick={this.toggleModal.bind(this, true)}>
            <i className="material-icons">preview</i>
          </a>
        </OverlayTrigger>
        
        { (detail.excel_download != null && detail.excel_create_date != null)
          ? <DropDown data={{
              btn  : <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip><p>エクセルのダウンロード<br />(最終更新日: {Utils.setDate(detail.excel_create_date, 'YYYY年M月D日 HH:mm')})</p></Tooltip>}>
                       <a className="button-item on"><i className="material-icons">download</i></a>
                     </OverlayTrigger>,
              menu : menu,
              key  : 'main-menu',
            }}/>
          : <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>投稿素材のダウンロードの準備中です</Tooltip>}>
              <a className="button-item off">
                <i className="material-icons">download</i>
              </a>
            </OverlayTrigger>
        }
        
        { (detail.my_authority == 99) &&
          <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>下書き編集（最高責任者のみ可能）</Tooltip>}>
            <a className={'button-item on '+ is_edit_mode} onClick={this.props.edit_mode_ev.bind(this)}>
              <i className="material-icons">edit</i>
            </a>
          </OverlayTrigger>
        }
        
        {/*<DraftPreviewModal view={this.state.modal} detail={detail} media={this.props.media} contents={contents} close_ev={this.toggleModal.bind(this)} />*/}
        
        <PostPreview view={this.state.modal} close_ev={this.toggleModal.bind(this)} detail={{
          media   : this.props.media,
          caption : contents.caption,
        }} />
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default DraftContentsHeader;